<div class="container-fluid">
  <div class="row section1">
    <div class="col-12 col-md-7 col-lg-4 col-xl-4">
      <div class="home-details">
        <h5 class="home-title">News Details</h5>
      </div>
    </div>
    <div class="col-12 col-md-8 col-lg-6 col-xl-6">
      <div class="dashboard-btn dashboard-manage">
        <div><a routerLink="/news">
          <button class="btn btn-primary btn-dashboard">Back</button>
        </a></div>
        <!-- <div> <a [routerLink]="['/entities/edit-entity/', entityId]"><button class="btn btn-primary btn-deshboard">Edit
              Details</button></a></div> -->
        <!--        <div class="cog-icn"><a><i class="las la-redo-alt"></i></a></div>-->
        <!--        <div class="cog-icn"><a><i class="las la-times"></i></a></div>-->
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12 ">
      <div class="applicants-details details1 pt-4">
        <h6 class="job-title">Article Details</h6>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
            <p>Article Id</p>
          </div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
            <p>{{article.id}}</p>
          </div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
            <p>Title</p>
          </div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
            <p>{{article.title}}</p>
          </div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
            <p>Short Description</p>
          </div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
            <p>{{article.shortDescription}}</p>
          </div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Description</p></div>
          <div class="col-6 col-md-6">
            <section [innerHTML]="article.description"></section>
          </div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Created By</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{article.admin.fullName}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
            <p>Image</p>
          </div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
            <img attr.src="{{article.thumbnail}}" alt="Profile Image" width="350">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--------end main container-fluid---------->
</div>
